import jQuery from 'jquery';
import _ from 'lodash';
import Rx from 'ub_wrapped/rx';
import getEditor from 'ub/utils/editor-utils';
import createElement from 'ub/create-dom-element';

const changeSubject = new Rx.Subject();

const removeStyleTag = (domElement) => {
  const styleTag = domElement.querySelector('.ub-svg-colors');

  if (styleTag) {
    styleTag.remove();
  }
};

const createStyleTag = (element, colorGroups) => {
  const styleNode = createElement('style', {
    class: 'ub-svg-colors',
    type: 'text/css'
  });

  const style = colorGroups.reduce((cssString, group) => {
    return `${cssString}
      #${element.id} .${group.id} { ${group.type}: ${group.color} }`;
  }, '');

  styleNode.innerHTML = style;

  return styleNode;
};

const updateStyleTag = (element, colorGroups) => {
  const domElement = element.view.e;
  removeStyleTag(domElement);

  const styleTag = createStyleTag(element, colorGroups);

  domElement.insert(styleTag);
};

const updatePom = (element) => {
  const editor = getEditor();
  const pomElement = _(editor.page.elements)
    .filter((pageEl) => {
      return pageEl.id === element.elementId;
    })
    .first();

  if (pomElement) {
    pomElement.model.set('svgColors', element.colorGroups);
  }
};

const updateElement = (element) => {
  updatePom(element);

  changeSubject.onNext({type: 'svgColorUpdated'});
};

const updateStyle = (element, isPublishOrPreviewMode) => {
  var colorGroups = element.model.safeGet('svgColors');
  if (colorGroups) {
    if (isPublishOrPreviewMode) {
      colorGroups.forEach(function(colorObj) {
        var rules = {
          attribute: colorObj.type,
          value: colorObj.color,
        };
        var selector = '#' + element.id + ' .' + colorObj.id;
        var options = { selector };
        element.applyPageStyles([rules], options);
      });
    }
    else {
      updateStyleTag(element, colorGroups);
    }
  }
};

const getSvgColor = (svg, type) => {
  const elsWithColor = [...svg.querySelectorAll(`[class*=-${type}-]`)];

  const colorObj = _(elsWithColor)
    .groupBy((element) => {
      return _.find(element.classList, classes => classes.includes(`-${type}-`));
    })
    .map((elements, key) => {
      const color = elements[0].getAttribute(type);
      return {
        id: key,
        color,
        type,
      };
    })
    .value();

  return colorObj;
};

// Ticket CN-1006: We add and remove this element to let the publisher know that
// we are waiting for a SVG to load and not to complete publishing until it has either
// completed loading or errored
const addSvgLoadingElement = () => {
  const svgLoadingElement = createElement('div', {
    class: 'ub-async-in-progress'
  });
  document.body.appendChild(svgLoadingElement);
  return svgLoadingElement;
};

const fetchSvg = (imageElm, imagePath, imageContainer, isPublishOrPreviewMode) => {
  const urlPath = isPublishOrPreviewMode ? `/publish${imagePath}`: imagePath;
  let svgLoadingElement;

  if (isPublishOrPreviewMode) {
    svgLoadingElement = addSvgLoadingElement();
  }

  jQuery.ajax({
    url: urlPath,
    type: 'GET',
    crossDomain: true,
    success: (svgDoc) => {
      const el = imageContainer.e.getElementsByTagName('img')[0];
      if (el) {
        el.remove();
      }

      imageElm.img = svgDoc.getElementsByTagName('svg')[0];

      imageContainer.insert(imageElm.img);

      if ( ! imageElm.model.safeGet('svgColors') && !isPublishOrPreviewMode) {
        const svgColor = [...getSvgColor(imageElm.img, 'fill'), ...getSvgColor(imageElm.img, 'stroke')];
        imageElm.model.set('svgColors', svgColor);
      }
    },
    error: (xhr, status, error) => {
      throw Error('Error fetching SVG:', error);
    },
    complete: () => {
      if (isPublishOrPreviewMode) {
        svgLoadingElement.remove();
      }
    }
  });
};

export default {
  updateElement,
  changeSubject,
  getSvgColor,
  fetchSvg,
  updateStyle,
};



// WEBPACK FOOTER //
// ./src/ui/svg/svg-helper.js